import Collapse from '@material-ui/core/Collapse';
import type { TrackedTranslation } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useState } from 'react';

import GreenArrow from '../../assets/icons/green-arrow.svg';
import Button from '../Button/Button';

import {
  active,
  arrow,
  buttonWrapper,
  container,
  expandButton,
  wrapper,
  wrapperInner
} from './CollapsibleHelpSection.scss';

interface Props {
  title: TrackedTranslation;
  content: TrackedTranslation;
}

const CollapsibleHelpSection: React.FC<Props> = ({ title, content }) => {
  const [expand, setExpand] = useState(false);

  const buttonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setExpand(!expand);
  };

  return (
    <div className={wrapper}>
      <div className={buttonWrapper}>
        <Button
          firstVariant="dropdown"
          translation={title}
          endIcon={<GreenArrow className={classNames(arrow, { [active]: expand })} />}
          className={expandButton}
          onClick={buttonClick}
        />
      </div>
      <Collapse classes={{ root: container, wrapperInner }} in={expand}>
        <Translation {...content} />
      </Collapse>
    </div>
  );
};
export default CollapsibleHelpSection;
